import { render, staticRenderFns } from "./xiaohei_order_check_detail.vue?vue&type=template&id=ff95e572&scoped=true"
import script from "./xiaohei_order_check_detail.vue?vue&type=script&lang=js"
export * from "./xiaohei_order_check_detail.vue?vue&type=script&lang=js"
import style0 from "./xiaohei_order_check_detail.vue?vue&type=style&index=0&id=ff95e572&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff95e572",
  null
  
)

export default component.exports